// @ts-nocheck a0c4f8c6
import tweenEngine from '../../localTweenEngine/localTweenEngine';

/** core.animationsFactory */
const { factory } = tweenEngine;

/**
 * FadeOut to opacity 0 animation object
 * @param {Array<HTMLElement>|HTMLElement} elements DOM element to animate
 * @param {Number} [duration]
 * @param {Number} [delay]
 * @param {Object} [params] optional parameters
 * @returns {TimelineMax}
 */
function animation(elements, duration, delay, params) {
  const sequence = factory.sequence(params);
  sequence.add(
    factory.animate('BaseFade', elements, duration, delay, {
      from: { opacity: 0 },
      to: { opacity: 1 },
    }),
    0,
  );

  return sequence.get();
}

animation.properties = {
  hideOnStart: true,
};

factory.registerAnimation('tooltipIn', animation);
